import styled from "styled-components"
const PaymentStyleWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 54px);
  height: 100%;
  padding: 40px 0;
`

export default PaymentStyleWrapper
